import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import SettingsContent from '../Wrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/iframe-creator'),
      component: SettingsContent,
      props: {
        headerTitle: 'IFRAME_CREATOR.HEADER',
        icon: 'people',
        showNewButton: true,
      },
      children: [
        {
          path: '',
          name: 'iframe_list',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
